/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { SET_SELECTED_CLASS } from '../../redux/constants';
import TeacherClassDetails from '../../pages/Teacher/Class/Teacher.ClassDetails';
import StudentClassDetails from '../../pages/Student/Class/Student.ClassDetails';
import { fetchClassById } from '../../service/class.service';

export default function ClassDetails() {
  const routeState = useLocation();
  const location = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedClass = useSelector((state) => state.classes.selectedClass);
  // const orgDetails = useSelector((state) => state.org.orgDetails);
  // const loggedInAs = useSelector((state) => state.auth.loggedInAs);
  // const { classData } = routeState.state;
  const [classDetail, setClassData] = useState({});
  // const classOrgRole =
  //   orgDetails.find((od) => od.orgId === classData?.orgId._id)?.role || loggedInAs;

  useEffect(() => {
    const getClassData = async () => {
      // const { classData } = routeState.state;
      if (routeState.state === null) {
        const res = await fetchClassById(location.id);
        if (res) {
          setClassData(res.fetchedClass);
          dispatch({ type: SET_SELECTED_CLASS, payload: res.fetchedClass });
          navigate(`/dashboard/classes/${location.id}`, {
            replace: true,
            state: {
              ...res.fetchedClass
            }
          });
        } else {
          navigate(-1);
        }
      } else {
        setClassData(routeState.state?.classData ?? routeState.state);
        if (Object.keys(selectedClass).length === 0)
          dispatch({
            type: SET_SELECTED_CLASS,
            payload: routeState.state?.classData ?? routeState.state
          });
      }
    };

    getClassData();
  }, [routeState]);

  return classDetail?.role ? (
    classDetail?.role === 'student' ? (
      <StudentClassDetails />
    ) : (
      <TeacherClassDetails />
    )
  ) : (
    <Box display="flex" width="100%" height="100%" justifyContent="center" alignItems="center">
      <CircularProgress />
    </Box>
  );
}
